const getters = {
  isLogged: () => true,
  isFiles: (state) => !state.loading, //&& ['Certificate of Inspection', 'Files', 'Data Archive', 'JGS Data', 'Public Data', 'JinSolution User Manual'].includes(state.route.name),
  isListing: (state, getters) => getters.isFiles && state.req.isDir,
  isEditor: (state, getters) => getters.isFiles && (state.req.type === 'text' || state.req.type === 'textImmutable'),
  selectedCount: (state) => state.selected.length,
}

export default getters
